export default __webpack_public_path__ + "static/eyes_of_the_sun-5434fd3368e04854724a297a4e831090.png";